import React from 'react';
import {isEmpty, map} from 'lodash';


class ErrorMsg extends React.Component {

    static htmlDecode = (value) => {
        let e = document.createElement('div');
        e.innerHTML = value;
        let elList = [];
        e.childNodes.forEach((a,z) => {
            elList.push(
                <li className="px-2" key={z}>
                    {a.textContent}
                </li>
            )
        })
        return elList;
    }

    renderError = () => {
        let errorList = null;
        try {
            if (!(isEmpty(this.props.errors))) {
                const { data } = this.props.errors;
                if (!(isEmpty(data)) && !(isEmpty(data.errors)) && data.errors.length) {
                    errorList = data.errors.map((error, i) => 
                        <li key={i}>
                            {
                                map(error, function(values, key) {
                                    return(
                                        <span key={key}>
                                            <label className="mb-0">{key}: </label>
                                            <ul>
                                            {
                                                values.map((value) => {
                                                    return ErrorMsg.htmlDecode(value);
                                                })
                                            }
                                            </ul>
                                        </span>
                                    );
                                }) 
                            }
                        </li>
                    );
                } else {
                    errorList = <li key={1}>{ErrorMsg.htmlDecode(data)}</li>
                }
            } else {
                errorList = <li key={1}>Something went wrong. Please Refresh the Page.</li>
            }
        } catch (error) {
            console.log(error);
            errorList = <li key={1}>Something went wrong. Please Refresh the Page.</li>
        }
        return errorList;
    }
   
    render() {
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <ul>{this.renderError()}</ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default ErrorMsg;


// WEBPACK FOOTER //
// ./src/components/common/ErrorMsg.js